import Footer from "../../../../Shared-Component/Footer/Footer"
import Header from "../../../../Shared-Component/Header/Header"
import CampusTitle from "../../../CampusSharedComponent/CampusTitles/CampusTitle/CampusTitle"
import CampusTableComponent from "../../../CampusSharedComponent/CampusTableComponent/CampusTableComponent";
import CampusHover from "../../../CampusSharedComponent/CampusHover/CampusHover"
import CampusGrid from "../../../CampusSharedComponent/CampusSections/CampusGridSection/CampusGrid"





const ExtenStudClubGrievPage = ({ data, hoverContent, tableData, threeHoverContent }) => {

  return (

    <>
      <Header />
      <div className='campusmaincontainer'>
        <div className='campus-container'>
          <CampusTitle title={data.pagename} />
          <CampusGrid content={data} />
          {
            hoverContent ? <><CampusHover title={data} content={hoverContent} />
            </> : <></>
          }
          {
            (tableData) ? <>
              <CampusTableComponent tableData={tableData} />
            </> : <></>
          }
        </div>
        <Footer />
      </div>
    </>

  )
}

export default ExtenStudClubGrievPage